import React from "react";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { About } from "../components/About";
import { Expertises } from "../components/Expertises";
import { Sector } from "../components/Sector";
import { Method } from "../components/Method";
import { Transparency } from "../components/Transparency";
import { Faq } from "../components/Faq";
import { Footer } from "../components/Footer";
export function Home() {
  return <div className="relative w-full bg-white" data-id="element-167" data-mp="1zka7r549rrja">
      <Header data-id="element-168" data-mp="24i3j0ckfjbqf" />
      <main data-id="element-169" data-mp="24hk7bdldhjku">
        <Hero data-id="element-170" data-mp="24j4rqadz3m4z" />
        <About data-id="element-171" data-mp="24ivapcawopbf" />
        <Expertises data-id="element-172" data-mp="29gd9waz4fq68" />
        <Sector data-id="element-173" data-mp="29fvfzkzxlo1h" />
        <Method data-id="element-174" data-mp="29fc1yfdejjsq" />
        <Transparency data-id="element-175" data-mp="29etvkpx0zp73" />
        <Faq data-id="element-176" data-mp="2dhqigstlm7gu" />
      </main>
      <Footer data-id="element-177" data-mp="2di8eboccmjo8" />
    </div>;
}